import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';

import { FormikFormGroup } from 'components/common';
import type { Backend } from 'archive/types';

type Props = {
  enableSpool?: boolean;
};

const DEFAULT_SPOOL_DIRECTORY = '/tmp/graylog-archive-spool';

const ArchiveBackendGCSFieldGroup = ({ enableSpool = true }: Props) => {
  const {
    values: { id },
    setFieldValue,
  } = useFormikContext<Backend>();

  useEffect(() => {
    if (!id) {
      if (enableSpool) {
        setFieldValue('settings.spool_directory', DEFAULT_SPOOL_DIRECTORY);
      }
      setFieldValue('settings.output_path', '');
    }
  }, [enableSpool, setFieldValue, id]);

  return (
    <>
      <FormikFormGroup
        name="settings.bucket"
        type="text"
        label="GCS Bucket"
        help="The name of your Google Cloud Storage bucket (must be globally unique)."
        labelClassName=""
        wrapperClassName=""
      />
      <FormikFormGroup
        name="settings.project_id"
        type="text"
        label="Project ID (optional)"
        help="Your Google Cloud project’s unique identifier."
        labelClassName=""
        wrapperClassName=""
      />
      <FormikFormGroup
        name="settings.endpoint_uri"
        type="text"
        label="Endpoint URI (optional)"
        help="Optional custom endpoint for accessing the storage (leave blank for default)."
        labelClassName=""
        wrapperClassName=""
      />
      {enableSpool && (
        <FormikFormGroup
          name="settings.spool_directory"
          type="text"
          label="Spool directory"
          help="Spool directory for this backend."
          labelClassName=""
          required
          wrapperClassName=""
        />
      )}
    </>
  );
};
export default ArchiveBackendGCSFieldGroup;
